import { useTranslation } from 'react-i18next'
import { Wrapper, Text, ImageContainer } from './PromoInfo.styled'
import { ReactComponent as SeagullLogo } from './assets/seagull.svg'
import { ReactComponent as VideotelLogo } from './assets/videotel.svg'

const PromoInfo: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Text data-test='PromoInfoText'>{t('promoInfo.poweredBy')}</Text>
      <ImageContainer data-test='PromoInfoLogos'>
        <SeagullLogo width='65' height='30' data-test='PromoInfoSeagullLogo' />
        <VideotelLogo width='80' height='15' data-test='PromoInfoVideotelLogo' />
      </ImageContainer>
    </Wrapper>
  )
}

export default PromoInfo
